module.exports = __webpack_public_path__ + "img/122ne.5a581364.svg";